import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  MpRecommendByScene({}, params) {
    return new Promise((resolve, reject) => {
      get('mp/recommend_scene/', params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
